export default __webpack_public_path__ + "static/about-us-1-layer-fe296ffe49e338f33d1947a9b5499556.png";